import { Mongo } from '../../meteorAdapter';

const Groups = new Mongo.Collection('groups', { defineMutationMethods: false })
export default Groups
